import React, {Component} from "react"
import styles from "./Header.module.css"
import mixedLogo from "./parts/img/mixed-logo.png"
import {ReactComponent as SignatureIcon} from "./parts/img/signature.svg"

interface Props {}

export class Header extends Component<Props, {}> {
    public render() {
        return (
            <header className={styles.root}>
                <div className={styles.wrapper}>
                    <h1 className={styles.h1}>
                        <img src={mixedLogo} alt="mixedinstitute-logo" />
                    </h1>
                    <div className={styles.rightWrapper}>
                        <SignatureIcon className={styles.signatureIcon} />
                        <span className={styles.text}>APPLY TO MIXED INSTITUTE</span>
                    </div>
                </div>
            </header>
        )
    }
}
